<template>
  <div class="container has-text-left">
    <div class="block">
      <div class="container has-text-left">
        <h5 class="title is-5">Notify on following event(s)</h5>
        <div class="level">
          <div class="level-left">
            <div class="level-item">Operator:</div>
            <div class="level-item">
              <b-select v-model="event.evaluation">
                <option v-for="evaluation in eventEvaluationTemplates"
                        :key="evaluation.id"
                        :value="evaluation.id"
                >{{evaluation.name}}
                </option>
              </b-select>
            </div>
          </div>
        </div>

        <div class="level"
             v-if="event.evaluation > 0 && selectedEvaluation && selectedEvaluation.args && selectedEvaluation.args.length > 0">
          <div class="level-left">
            <div class="level-item" v-for="(arg, index) in selectedEvaluation.args"
                 :key="arg.label"
            >
              <span style="margin-right: 0.5rem;">{{arg.label}}</span>
              <b-input required v-model="event.args[index]"/>
            </div>
          </div>
        </div>

        <div class="level">
          <div class="level-left">
            <div class="level-item">Count:</div>
            <div class="level-item">
              <b-input v-model="count" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons">
      <b-button type="is-success" :disabled="!validCreateAutomation()" @click="handleCreateAutomation">Create</b-button>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BButton from "buefy/src/components/button/Button";
  import BSelect from "buefy/src/components/select/Select";
  import BInput from "buefy/src/components/input/Input";

  export default {
    components: {
      BInput,
      BSelect,
      BButton,
    },
    name: "notify-on-object-event",
    props: ['id'],
    data() {
      return {
        name: '',
        object: null,
        event: {
          objectId: 0,
          evaluation: 1,
          args: []
        },
        count: 1,
        action: {
          type: "notify",
          notify: {
            mapUserChannels: {}
          }
        },
        storedEvents: [],
        storedActions: []
      };
    },
    computed: {
      ...mapGetters('objects', ['groupById', 'objects', 'objectTypes', 'objectsByObjectType', 'objectById']),
      ...mapGetters('notifications', ['notificationHandlers']),
      ...mapGetters('automations', ['eventEvaluationTemplates', 'conditionOperators', 'scheduleRepeatTemplates', 'scheduleRepeatTemplateById', 'automationsAvailableForRun', 'automationById']),
      ...mapGetters('auth', ['userList', 'userData']),
      usersAvailableForNotifications() {
        const ret = [];

        this.userList.forEach(item => {
          ret.push({
            ...item
          });
        });

        return ret;
      },
      selectedEvaluation() {
        const filtered = this.eventEvaluationTemplates.filter(item => {
          return parseInt(item.id, 10) === parseInt(this.event.evaluation, 10);
        });

        return typeof filtered[0] !== 'undefined' ? filtered[0] : null;
      },
      logicOptions() {
        return ["and", "or"];
      },
      eventsTableData() {
        let num = 0;
        return this.storedEvents.map(item => {
          num++;
          const object = this.objectById(item.objectId);
          const e = this.eventEvaluationTemplates.filter(evalItem => {
            return parseInt(evalItem.id) === parseInt(item.evaluation);
          });
          const ev = e[0];
          let description = ev['name'];
          if (ev.args) {
            const arr = [];
            ev.args.forEach((arg, idx) => {
              arr.push(`${arg['label']} ${item.args[idx]}`);
            });
            description = arr.join(' ');
          }
          return {
            ...item,
            num,
            object,
            evaluationName: description
          };
        });
      },
      actionsTableData() {
        let num = 0;
        return this.storedActions.map(item => {
          num++;
          let description = '';
          if (item['type'] === "") {
            description = `Execute ${item.command.command} -> ${item.command.message}`;
          }

          if (item['type'] === 'set_object_state') {
            const { objectId, value } = item.setObjectState;
            description = `Set object ${objectId} to ${value}`;
          }

          if (item['type'] === "run_automation") {
            const { id: automationId } = item.runAutomation;
            const targetAutomation = this.automationById(automationId);
            if (targetAutomation) {
              description = `Run automation "${targetAutomation.name}" [id: ${automationId}]`;
            }
          }

          if (item['type'] === "notify") {
            const { mapUserChannels } = item['notify'];
            const arrUsers = [];
            Object.keys(mapUserChannels).forEach(username => {
              const itemUser = mapUserChannels[username];
              let found = false;
              Object.keys(itemUser).forEach(channel => {
                if (parseInt(itemUser[channel]) === 1) {
                  found = true;
                }
              });
              if (found) {
                arrUsers.push(username);
              }
            });
            description = `Notify ${arrUsers.join(', ')}`;
          }

          return {
            ...item,
            num,
            description
          };
        });
      }
    },
    methods: {
      ...mapActions('automations', ['createLimitedAutomation']),
      isAnyUserNotified() {
        let foundChecked = false;
        Object.keys(this.action.notify.mapUserChannels).forEach(username => {
          const itemUsername = this.action.notify.mapUserChannels[username];
          Object.keys(itemUsername).forEach(channel => {
            const itemChannel = itemUsername[channel];
            if (parseInt(itemChannel) === 1) {
              foundChecked = true;
            }
          });
        });

        return foundChecked;
      },
      validCreateAutomation() {
        return true;
      },
      handleCreateAutomation() {
        this.createLimitedAutomation({
          event: this.event,
          action: this.action,
          count: this.count || 1
        });
        this.$router.push('/');
      }
    },
    created() {
      this.object = this.objectById(this.id);
      this.event.objectId = this.id;
    },
    mounted() {
      if (this.userList && this.notificationHandlers) {
        this.userList.forEach(user => {
          if (user.username.toLowerCase() === this.userData.username.toLowerCase()) {
            this.action.notify.mapUserChannels[user.username] = {};
            this.notificationHandlers.forEach(handler => {
              this.action.notify.mapUserChannels[user.username][handler.channel] = 3;
            });
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>